//服务于active伪类
window.log = console.log.bind(console)

// safari ios 10  下禁止双击缩放
var lastTouchEnd=0;
document.addEventListener('touchend',function (event) {
  var now=(new Date()).getTime();
  if(now-lastTouchEnd<=300){
    event.preventDefault();
  }
  lastTouchEnd=now;
},false)
// safari ios 10  下禁止用户手势缩放
document.addEventListener('gesturestart', function (event) {
  event.preventDefault();
});


function fontAdjust() {
  document.documentElement.style.fontSize = 20 * document.documentElement.clientWidth / 375 + 'px';
}

window.addEventListener('resize', fontAdjust);
fontAdjust();
export default fontAdjust;




// WEBPACK FOOTER //
// ./node_modules/bjxy-common/helper/jsReset.js